
<div class="header-toolbar">
  <h1>
    Dossiers
    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/dossiers/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <a class="btn" [routerLink]="'/dossiers/import'">
        <t-icon name="add"></t-icon>
        <span class="text">Importer</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/dossiers/archive'">
        <t-icon name="folder"></t-icon>
        <span class="text">Archive</span>
      </a>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 320px">INPI</th>
      <th style="width: 110px">Date d'ajout</th>
      <th style="width: 120px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="dossiers && dossiers.length > 0">
    <tr *ngFor="let dossier of dossiers" (click)="showDossier(dossier, $event)">
      <td name="Nom">
        {{ dossier.name }}
      </td>
      <td name="INPI" class="icons inpi-icons" style="width: 320px">
        <span *ngIf="!dossier.inpi.message">
          <t-icon name="check"></t-icon>
        </span>
        <span *ngIf="dossier.inpi.message">
          <t-icon name="warning"></t-icon>
          {{ dossier.inpi.message }}
        </span>
      </td>
      <td name="Date d'ajout" style="width: 110px">
        {{ dossier.created_at | tzdate:'short' }}
      </td>
      <td style="width: 120px;" class="actions">
        <a class="action-btn" title="Archiver" (click)="archive(dossier)">
          <t-icon name="archive"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(dossier)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!dossiers || dossiers.length == 0">
    <tr>
      <td class="text-center" colspan="4">
        <ng-container *ngIf="dossiers && dossiers.length == 0">
          Aucun dossier n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!dossiers">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="dossiers">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="dossiers.length < dossiersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ dossiers.length }} / {{ dossiersCount }}
  </div>
</div>